import PropTypes from 'prop-types';
import React from 'react';
import TagStyle from './priceTag.module.scss';

function PriceTag(props) {
  const {
    type, priceValue, unitSize, unit, fontColor, resetStyle, isSpace,
  } = props;

  /**
   *
   * @param {number} x 价格
   * @returns 1000 => 1,000
   */
  const priceSwitch = (x) => {
  // 强制保留两位小数
    let f = parseFloat(x);
    if (Number.isNaN(f)) return false;
    f = Math.round(x * 100) / 100;
    let s = f.toString();
    const rs = s.indexOf('.');
    if (rs < 0) {
    // rs = s.length;
      s += '.';
    }
    // while (s.length < (rs + 1) + 2) {
    //   s += '0';
    // }
    // 每三位用一个逗号隔开
    let leftNum = s.split('.')[0];
    const rightNum = `.${s.split('.')[1]}`;
    let result;
    // 定义数组记录截取后的价格
    const resultArray = [];
    if (leftNum.length > 3) {
      let i = true;
      while (i) {
        resultArray.push(leftNum.slice(-3));
        leftNum = leftNum.slice(0, leftNum.length - 3);
        if (leftNum.length < 4) {
          i = false;
        }
      }
      // 由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
      const sortArray = [];
      for (let j = resultArray.length - 1; j >= 0; j -= 1) {
        sortArray.push(resultArray[j]);
      }
      result = `${leftNum},${sortArray.join(',')}${rightNum}`;
    } else {
      result = s;
    }
    return result.replace('.', '');
  };

  const priceType = {
    normal: 'normal', // 正常
    member: 'member', // 会员价
    perfer: 'perfer', // 优惠价
    normalPerfer: 'normalPerfer', // 普通优惠价
  };
  const priceTypeColor = {
    normal: '#111111', // 正常
    member: '#0077C8', // 会员价
    perfer: '#666666', // 优惠价
    normalPerfer: '#666666', // 普通优惠价
  };

  //  根据type计算默认样式
  const defalutStyle = (defaultTyope) => {
    switch (defaultTyope) {
      case priceType.normal:
        return {
          color: fontColor || priceTypeColor.normal,
          fontWeight: 'bold',
        };
      case priceType.member:
        return {
          color: fontColor || priceTypeColor.member,
          fontWeight: 'bold',
        };
      case priceType.perfer:
        return {
          color: fontColor || priceTypeColor.perfer,
        };
      case priceType.normalPerfer:
        return {
          color: fontColor || priceTypeColor.normalPerfer,
        };
      default:
        return {
          fontWeight: 'bold',
        };
    }
  };

  //  根据type渲染dom
  const renderPriceDom = (compType) => {
    switch (compType) {
      case 'normal':
      case 'member':
        return (
          <span className={TagStyle['calculate-price']}>
            <span className={TagStyle['price-symbol']}>
              {isSpace ? '¥ ' : '¥'}
            </span>
            <span
              className={TagStyle.price}
              style={{
                fontSize: `${unitSize}${unit}`,
                lineHeight: '1.2',
              }}
            >
              {priceSwitch(priceValue)}
            </span>
            <span className={TagStyle['price-end']}>.00</span>
          </span>
        );
      case 'perfer':
        return (
          <>
            <span
              className={TagStyle['perfer-price']}
              style={{
                fontSize: `${unitSize}${unit}`,
              }}
            >

              <span>
                {isSpace ? '¥ ' : '¥'}
              </span>
              <span>{priceSwitch(priceValue)}</span>
              <span>.00</span>
            </span>
          </>
        );
      case 'normalPerfer':
        return (
          <>
            <span
              style={{
                fontSize: `${unitSize}${unit}`,
              }}
            >
              <span>
                {isSpace ? '¥ ' : '¥'}
              </span>
              <span>{priceSwitch(priceValue)}</span>
              <span>.00</span>
            </span>
          </>
        );
      default:
        return '';
    }
  };

  return (
    <>
      <p
        className={TagStyle['info-price-price']}
        style={{
          ...defalutStyle(type),
          ...resetStyle,
        }}
      >
        {
          renderPriceDom(type)
        }
      </p>
    </>
  );
}

PriceTag.propTypes = {
  type: PropTypes.string,
  priceValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.string,
  unitSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontColor: PropTypes.string,
  resetStyle: PropTypes.objectOf(PropTypes.any),
  isSpace: PropTypes.bool,
};
PriceTag.defaultProps = {
  type: 'normal', // 价格类型
  priceValue: '1000', // 价格
  unitSize: '1.125', // 12/16
  unit: 'rem', // 字体大小单位
  fontColor: '', // 字体颜色（整体）
  resetStyle: {},
  isSpace: false,
};

export default PriceTag;
